export const routes = {
  public: {
    signup: '/signup',
    phoneConfirmation: '/phone-confirmation',
    logout: '/logout',
  },

  brokerOffer: {
    base: '/broker-offer',
    view: (offerId: string) => `/broker-offer/${offerId}`,
    confirmPhone: (offerId: string) => `/broker-offer/${offerId}/confirm-phone`,
    otp: (offerId: string) => `/broker-offer/${offerId}/otp`,
  },

  wizard: {
    base: '/wizard',
  },

  appRedirect: '/app-redirect',

  onboarding: {
    base: '/onboarding',
    cnp: '/onboarding/cnp',
  },

  email: {
    base: '/email',
    confirmation: '/email/confirmation',
    // Public landing for the validation link sent by email. Also the path the
    // mobile app claims as a universal / app link.
    validationLink: '/email-validation',
  },

  questionnaire: {
    base: '/questionnaire',
    financialNeed: '/questionnaire/financial-need',
    desiredAmount: '/questionnaire/desired-amount',
  },

  // BC score and preliminary offer before KYC
  scoring: {
    base: '/scoring',
    income: '/scoring/income',
    terms: '/scoring/terms',
    phones: '/scoring/phones',
    code: '/scoring/code',
  },

  kyc: {
    base: '/kyc',
    inProgress: '/kyc/in-progress',
    failed: '/kyc/failed',
    manualAddress: '/kyc/manual-address',
    proofOfAddress: '/kyc/proof-of-address',
  },

  terms: {
    base: '/terms',
    anaf: '/terms/anaf',
    // ANAF consent alone, after KYC
    anafConsent: '/terms/anaf-consent',
    bc: '/terms/bc',
    partner: '/terms/partner',
  },

  offer: {
    base: '/offer',
    terms: '/offer/terms',
    processingAnaf: '/offer/processing-anaf',
    inProgress: '/offer/in-progress',
    notAvailable: '/offer/not-available',
    // No final credit offer, a Volt product instead
    voltAlternative: '/offer/volt-alternative',
    voltZeroLanding: '/offer/volt-alternative/volt-zero',
    anafInProgress: '/offer/anaf-in-progress',
    proofOfIncome: '/offer/proof-of-income',
    preliminary: '/offer/preliminary',
    preliminaryDetails: (type: 'credit-line' | 'installment') =>
      `/offer/preliminary/${type}`,
    preliminaryCalculator: (tab: 'credit-line' | 'installment') =>
      `/offer/preliminary/calculator/${tab}`,
    preliminaryAppRedirect: '/offer/preliminary/app-redirect',
    // Without a preliminary offer: low BC score
    preliminaryNotAvailable: '/offer/preliminary/not-available',
    // Without a preliminary offer: rejected on income or debt ratio
    preliminaryRefinance: '/offer/preliminary/refinance',
    // The refinance landing, for the same users
    preliminaryRefinanceLanding: '/offer/preliminary/refinance/details',
    // Without a BC score at all (no credit history)
    preliminaryNoScore: '/offer/preliminary/no-score',
    // The Volt Zero landing, for users without a credit history
    preliminaryVoltZero: '/offer/preliminary/volt-zero',
  },

  bankCard: {
    add: '/bank-card/add',
    addResult: '/bank-card/add/result',
    addFailed: '/bank-card/add/failed',
  },

  application: {
    base: '/application',
    calculator: '/application/calculator',
    calculatorTab: (tab: 'credit-line' | 'installment') =>
      `/application/calculator/${tab}`,
    installmentConfirmation: '/application/installment-confirmation',
    creditLineConfirmation: '/application/credit-line-confirmation',
    creditLineAmount: '/application/credit-line-amount',
    creditLinePaymentDate: '/application/credit-line-payment-date',
    derogationDeclaration: '/application/derogation-declaration',
    // The chosen preliminary credit has no final offer, the other one has.
    alternativeOffer: '/application/alternative-offer',
  },

  loan: {
    base: '/loan',
    sign: '/loan/sign',
    active: '/loan/active',
  },
} as const;
